import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import eightAxios from "configs/axiosConfig";
import { fetchDataFromApi } from "utils";

import * as Yup from "yup";
import {
  BANNER_TITLE_URL, POLICY_SUMMARY_URL, WORKER_TYPES_URL,

} from "../../../configs/constants";
import Table from "components/Table";
import Filter from "@Components/Filter";

let model = [

  { id: "company_name", label: "Company", type: "string" },
  { id: "active", label: "Total Active Worker", type: "string" },
  { id: "agreed", label: "No. Of Worker Agree", type: "string" },
  { id: "not_agreed", label: "No. Of Worker Disagree", type: "string" },
  { id: "not_responded", label: "No. Of Worker Not Responding", type: "string" },
  { id: "agreed_percent", label: "% Of Worker Agree", type: "string" },
  { id: "not_agreed_percent", label: "% Of Worker Disagree", type: "string" },
  { id: "not_responded_percent", label: "% Of Worker Not Responding", type: "string" },


];




// const filterInitialValues = {
//   date: null,
//   employee_id: "",
//   name: "",
//   company: "",
//   zone: "",
//   region: "",
//   estate: "",
// };

const policySummary = () => {
  const [filterValues, setFilterValues] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [selectedFormDate, setSelectedFormDate] = useState(null);
  const [selectedtoDate, setSelectedToDate] = useState(null);
  const [filterFields, setFilterFields] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [defaultBanner, setDefaultBanner] = useState({
    id: "",
    name: ""
  });

  const [selectedBanner, setSelectedBanner] = useState({
    id: null,
    name: null,
    isActive: false
  })
  const [allBanners, setAllBanners] = useState([])
  const [filterInitialValues, setFilterInitialValues] = useState({})

  const details = useLocation();
  const URLS = {
    POLICY_LOG: "/report/policy/",
  };
  const today = new Date();
  const options = { timeZone: 'Asia/Kuala_Lumpur' };
  let date = today.toLocaleDateString('en-GB', options);
  date = date.split('/').reverse().join('-');


 

 


  const getTopBannerID = async () => {
    try {
      const response = await eightAxios.get(BANNER_TITLE_URL);
      const bannerData = response.data[0];
      setSelectedBanner({
        id: bannerData.id,
        name: bannerData.name,
      });
      setAllBanners(response.data)
      setFilterInitialValues({
        banner: bannerData.id,
        workerType: null, 
      })

      const bannerOptions = [{ value: bannerData.name, label: bannerData.name }];
      // Update filterFields with the fetched banner name only on initial load

      if (isInitialLoad) {
        // Update filterFields with the fetched banner name only on initial load
        setFilterFields([
          {
            type: "reactselect",
            name: "banner",
            label: "Policy Title",
            required: true,
            proxyUrl: BANNER_TITLE_URL,
            paginated: false,
            value: bannerData.name,
          },
          {
            type: "reactselect",
            name: "worker-type",
            label: "Worker Type",
            proxyUrl: WORKER_TYPES_URL,
            paginated: false,
          },
        ]);

        setIsInitialLoad(false);
        setFilterFields([
          {
            type: "reactselect",
            name: "banner",
            label: "Policy Title",
            required: true,
            proxyUrl: BANNER_TITLE_URL,
            paginated: false,
            value: "",
          },
          {
            type: "reactselect",
            name: "worker-type",
            label: "Worker Type",
            proxyUrl: WORKER_TYPES_URL,
            paginated: false,
          },
        ]);

      } else {
        setFilterFields([
          {
            type: "reactselect",
            name: "banner",
            label: "Policy Title",
            required: true,
            proxyUrl: BANNER_TITLE_URL,
            paginated: false,
            value: "",
          },
          {
            type: "reactselect",
            name: "worker-type",
            label: "Worker Type",
            proxyUrl: WORKER_TYPES_URL,
            paginated: false,
          },
        ]);
      }

    } catch (error) {
      console.error("error fetching selectedBanner", error);
    }
  };



  useEffect(() => {
    getTopBannerID();
  }, []);



  /* const filterFields =[
 
     {
       type: "reactselect",
       name: "banner",
       label: "Policy Title",
       required: true,
       proxyUrl: BANNER_TITLE_URL,
       paginated: false,
       defaultValue: defaultBannerName,
     },
 
     {
       type: "reactselect",
       name: "worker-type",
       label: "Worker Type",
       proxyUrl: WORKER_TYPES_URL,
       paginated: false,
 
     },
 
   ];  */

 


  const validationSchema = Yup.object({
    banner: Yup.string().required("Policy Title is required").typeError("Policy Title is required"),

  });


 


  let filters = {};

  //const [filterInitialValues, setFilterInitialValues] = useState({});

  /* const onFilterRequest = (values) => {
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
    console.log("Test filter",filterValues);
    console.log("test setAllBanners", allBanners);
    
    
  }; */

  useEffect(() => {
    fetchDataFromApi('/report/policy-list/', setDefaultBanner, false);
  }, [filterFields]);

  useEffect(() => {
    console.log("test data defaultBanner",defaultBanner);
    
  }, [defaultBanner]);
  

  const onFilterRequest = (values) => {
    setFiltersApplied(true);
  
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        if (key === "banner" && typeof value === "string") {
          // Find the banner that matches the string value and get its id
          const matchingBanner = allBanners.find(banner => banner.name === value);
          if (matchingBanner) {
            filterObj[key] = matchingBanner.id;
          } else {
            filterObj[key] = value; // if no match is found, keep the original value
          }
        } else {
          filterObj[key] = value;
        }
      }
    }
    setFilterValues(filterObj);
    console.log("Test filter", filterValues);
    console.log("test setAllBanners", allBanners);
  };
  


 const clearFilter = () => {
  /* setFilterFields([
    {
      type: "reactselect",
      name: "banner",
      label: "Policy Title",
      required: true,
      proxyUrl: BANNER_TITLE_URL,
      paginated: false,
      value: null,
    },
    {
      type: "reactselect",
      name: "worker-type",
      label: "Worker Type",
      proxyUrl: WORKER_TYPES_URL,
      paginated: false,
    },
  ]);
    console.log("Cleared");
    alert("Cleared") */
    
 }
  
  return (
    <>
      <Filter
        filterFields={filterFields}
        initialValues={filterInitialValues}
        onSubmit={onFilterRequest}
        validationSchema={validationSchema}
        onClear={clearFilter}
      />

      {filtersApplied ? (

        <Table
          proxyURL={POLICY_SUMMARY_URL}
          model={model}
          filterValues={filterValues}
          noFilter
          noAddButton
          paginationDisable={true}
          grandTotalEnable={true}
        />
      ) : (
        selectedBanner.id !== null && (
          <Table
            proxyURL={`report/policy/?banner=${selectedBanner.id}`}
            model={model}
            filterValues={filterValues}
            noFilter
            noAddButton
            paginationDisable={true}
            grandTotalEnable={true}
          />
        )

      )}


    </>
  );
};
export default policySummary;
